import { ReactNode } from 'react';
import {
    DetailsHeaderWithIcon,
    DetailsHeaderWithIconProps,
} from 'components/atoms/Details/DetailsHeaderWithIcon/DetailsHeaderWithIcon';
import { AppFlex } from 'components/atoms/CommonAppComponents';
import styled, { css } from 'styled-components';
import { Row } from 'antd';
import { Option, OptionsButton } from 'components/atoms/AppTableAndListCommon';
import { Container } from './DetailsFrameBase.styled';

export type DetailsFrameBaseProps<ItemType> = Partial<DetailsHeaderWithIconProps> & {
    children?: ReactNode;
    additionalHeaderContent?: ReactNode;
    noFrame?: boolean;
    hideHeader?: boolean;
    marginEnd?: number;
    className?: string;
    options?: Option<ItemType>[];
    noMarginLeft?: boolean;
    smallHeaderMargin?: boolean;
    headerColor?: string;
    iconColor?: string;
    record?: ItemType;
    index?: number;
    accessibilityLabel?: string;
};

const StyledHeaderContainer = styled(AppFlex)<{ smallHeaderMargin?: boolean }>`
    ${({ theme, smallHeaderMargin }) => css`
        margin-bottom: ${smallHeaderMargin ? theme.sizes.marginNormal : theme.sizes.marginLarge}px;
    `}
`;

// eslint-disable-next-line
export const DetailsFrameBase = <ItemType = any,>({
    icon,
    title,
    children,
    additionalHeaderContent,
    noFrame = false,
    smallHeaderMargin,
    hideHeader = false,
    marginEnd,
    className,
    options,
    noMarginLeft,
    headerColor,
    iconColor,
    record,
    index = 0,
    accessibilityLabel,
}: DetailsFrameBaseProps<ItemType>) => (
    <Container
        noFrame={noFrame}
        marginEnd={marginEnd}
        className={className}
        aria-label={accessibilityLabel}
    >
        <Row justify="space-between">
            {!hideHeader && (
                <StyledHeaderContainer
                    gap="middle"
                    align="center"
                    smallHeaderMargin={smallHeaderMargin}
                >
                    <DetailsHeaderWithIcon
                        icon={icon}
                        title={title || ''}
                        noMarginLeft={noMarginLeft}
                        headerColor={headerColor}
                        iconColor={iconColor}
                    />
                    {additionalHeaderContent}
                </StyledHeaderContainer>
            )}
            {options && record && (
                <OptionsButton<ItemType>
                    options={options}
                    openOptionsButtonSize="BIG"
                    record={record}
                    index={index}
                />
            )}
        </Row>
        {children}
    </Container>
);
